



























import Component from 'vue-class-component';

import { IgetSearchGetDepartmentMarkingDataChildren } from '@/store/specialist/index.d';
import { dispatchGetHospitalDetail, dispatchGetHospitalDepts } from '@/store/specialist';
import Webview from '@/webview';

interface IdepartmentItem {
  text: string;
  id: number;
  children?: IdepartmentItem[];
}

@Component
export default class HospitalDetail extends Webview {
  data = {};

  depts: IdepartmentItem[] = [];

  activeIndex = 0;

  async created() {
    const { id } = this.$route.params;
    this.data = await dispatchGetHospitalDetail(this.$store, { hospitalId: Number(id) });
    await this.fetchDepts(id);
  }

  async fetchDepts(id: string) {
    const { data } = await dispatchGetHospitalDepts(this.$store, { hospitalId: Number(id) });

    data.unshift({
      label: '全部科室',
      value: -1,
      children: ([] as IgetSearchGetDepartmentMarkingDataChildren[]).concat(...data.map(({ children }) => children))
    });

    this.depts = data.map(
      (val): IdepartmentItem => ({
        text: val.label,
        id: val.value,
        children: val.children.map(childVal => ({ text: childVal.label, id: childVal.value }))
      })
    );
  }

  linkUrl(id: number) {
    this.$router.push(`${this.constant.HOSPITAL_INTRO}/${id}`);
  }

  linkSpeciallist(data: IdepartmentItem) {
    const { id } = this.$route.params;

    this.$router.push({
      name: this.constant.DEPARTMENT_SPECIALIST,
      query: {
        hospitalId: id,
        departmentId: data.id.toString(),
        departmentType: '2',
        departmentName: data.text
      }
    });
  }
}
